export const CLASS_NAME = 'basic_confirm_modal';

export const POSITION = {
  TOP: 'top',
  MIDDLE: 'middle',
};

export const TOGGLE_TYPE = {
  CANCEL: 'cancel',
  CLOSE: 'close',
  SUBMIT: 'submit'
};
